import { UUID } from '@litlingo/client';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import { useNavParamsByResource } from 'hooks/nav/useNavParamsByResource';
import { RequestParamsType, RequestResponse } from 'hooks/types/client';
import { useParams } from 'react-router-dom';
import useRequest from '../client/useRequest';

type Options = { enabled?: boolean };

type UseInvestigationEnvelopes = (
  investigationId?: UUID,
  options?: Options
) => RequestResponse<'investigations.extras.listEnvelopes'>;

const useInvestigationEnvelopes: UseInvestigationEnvelopes = (investigationId, options) => {
  const { investigationId: routeInvestigationId } = useParams<{ investigationId: string }>();
  const id = investigationId ?? routeInvestigationId;
  const resourceParams = useNavParamsByResource(resourceQueryParamName.investigationEnvelopes);

  const params: RequestParamsType = {
    urlParams: { investigationId: id ?? '' },
    queryParams: {
      ...resourceParams,
      include_count: true,
      relationships: ['created_by', 'updated_by'],
      include_pii: true,
    },
  };

  return useRequest('investigations.extras.listEnvelopes', params, {
    enabled: (options?.enabled ?? true) && Boolean(id),
  });
};

export default useInvestigationEnvelopes;
